import React, { memo } from 'react';
import { Text, Stack, Label, Checkbox, DefaultButton, Spinner, Dropdown, MessageBar, MessageBarType, PrimaryButton, ChoiceGroup } from '@fluentui/react';
import { useDispatch, useSelector } from "react-redux";
import Type from "../../Redux/Type";
import { onLoadQuyHoachPolygon, onLoadQHChiTietTanChau } from '../../Containers/QuyHoach'
import { onOpenRightPanel } from "../../Containers/RightPanelAction";
import { onLoadXa } from '../../Containers/ViTriHanhChinh';
import { onMoveToMap } from '../../Containers/MapView';
import { checkQuyenXemQuyHoach } from './../../Containers/MainController';
import { useState } from 'react';
import { Modal } from 'antd';
import { store } from "../../Redux/Store";
import COLOR from '../../Styles/Colors';
import CardDownApp from '../Menu/CardDownApp';

const Layer = () => {
    const { showThuaDat } = useSelector(state => state.hienTrang);
    const { menuDiaGioi, huyenselect } = useSelector(state => state.diaGioi);
    const { showQuyHoach, typeActive, isLoading, errorMessage, listLabel, menu } = useSelector(state => state.quyHoach);
    const dispatch = useDispatch();
    const userInfo = useSelector(state => state.userInfo);

    //Code bổ sung chọn nhiều quy hoạch
    const [arrQuyHoach, setQuyHoachArr] = useState([])


    const onChangeShowQuyHoachStatus = () => {
        if(!showQuyHoach){
            dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'showThuaDat', value: false });
        }
        dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'showQuyHoach', value: !showQuyHoach });
    };
    const onChangeHuyen = (_, option) => {
        let huyen = { key: option.key, text: option.text }
        let center = {
            lat: parseFloat(option.latitude),
            lng: parseFloat(option.longitude)
        };
        onMoveToMap(center)
        onLoadXa(huyen)
    }
    const onChangeShowThuaDatStatus = () => {
        // if (!userInfo) {
        //     alert('Vui lòng đăng nhập đễ xem lớp thửa đất')
        //     dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'showThuaDat', value: false });
        // } else {
        dispatch({ type: Type.SET_STATE_HIEN_TRANG, route: 'showThuaDat', value: !showThuaDat });
        // }

    };

    const onChangeTypeQuyHoach = (_, typeActive) => {
        typeActive.coordinate = { lat: parseFloat(typeActive['lat']), lng: parseFloat(typeActive['lng']) }
        dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'typeActive', value: typeActive });
    }

    const onLoadPress = () => {
        //Code cũ 
        if (typeActive.key) {
            store.dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'errorMessage', value: "" });
            if (typeActive.key === 'CTSDDTTCT') {
                onLoadQHChiTietTanChau();
                onOpenRightPanel('zone')
                // Tắt form xem quy hoạch 
                dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'isShowForPopup', value: false });
                dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'routeContent', value: null });
            }
            else {
                // TPTN_PK2_GIAOTHONG  TPTN_PK2_CAPDIEN TPTN_PK2_CAPNUOC
                // console.log(typeActive.key)
                onLoadQuyHoachPolygon(typeActive.key);
            }
        }
        else {
            store.dispatch({ type: Type.SET_STATE_QUY_HOACH, route: 'errorMessage', value: "Vui lòng chọn loại quy hoạch" });
        }

    }

    //Code bổ sung chọn nhiều quy hoạch
    const setChonQuyHoach = (item) => {
        try {
            let arr = arrQuyHoach
            if (arr.filter(e => e.key === item.key).length > 0) {
                arr = arr.filter(e => e.key !== item.key)
                setQuyHoachArr(arr)
            }
            else {
                setQuyHoachArr(arr.push(item))
            }
        } catch (error) {

        }
    }

    const filterMenu = () => {
        let menuR = menu.filter((e) => e.Ten.trim() === huyenselect.text.trim())
        return menuR
        // return menuR.filter(e => checkQuyenXemQuyHoach(e.text, userInfo.Username) === true)
    }


    return (
        <div className='modal-content-container'>
            <div className='animated-panel'>
                <Text variant='xLarge' className='title'>Lớp bản đồ</Text>
                <Stack tokens={{ childrenGap: 20 }} style={{ flex: 1 }}>
                    <Stack tokens={{ childrenGap: 5 }}>
                        {/* <Label>Hiển thị bản đồ</Label> */}
                        <Stack horizontal tokens={{ childrenGap: 20 }}>
                            {/* <Checkbox checked={showThuaDat} onChange={onChangeShowThuaDatStatus} label="Lớp thửa đất" /> */}
                            <Checkbox
                                label="Hiển thị bản đồ"
                                onChange={onChangeShowQuyHoachStatus}
                                checked={showQuyHoach}
                                disabled={isLoading}
                            />
                        </Stack>
                    </Stack>
                    <Stack tokens={{ childrenGap: 5 }}>
                        <Label>Đơn vị hành chính</Label>

                        <Dropdown
                            options={menuDiaGioi}
                            selectedKey={huyenselect.key}
                            onChange={onChangeHuyen}
                            disabled={!showQuyHoach || isLoading}
                        />
                    </Stack>
                    <Stack styles={styles.container} >

                        {/* ==> Code cũ cần giữ */}
                        {
                            filterMenu() && filterMenu().length ?
                                <ChoiceGroup
                                    disabled={!showQuyHoach || isLoading}
                                    style={{ paddingBottom: 10, paddingTop: 10, maxHeight: window.innerHeight < 520 ? 85 : window.innerHeight > 520 && window.innerHeight < 589 ? 140 : 230 }}
                                    selectedKey={typeActive.key}
                                    options={filterMenu()}
                                    onChange={onChangeTypeQuyHoach}
                                />
                                :
                                (
                                    showQuyHoach ?
                                        (
                                            <Stack>
                                                <Text style={styles.lableEmpty} >Quy hoạch của {huyenselect.text} đang cập nhật. Vui lòng chọn đơn vị hành chính khác</Text>
                                            </Stack>
                                        )
                                        : null
                                )
                        }



                        {/* {
                            filterMenu().map(e=>(
                                <Checkbox styles={styles.checkBoxV2} key={Math.random() + 11} disabled={!showQuyHoach} onChange={() => {setChonQuyHoach(e)}} label={e.text} />
                            ))
                        } */}


                    </Stack>
                    <Stack horizontal tokens={{ childrenGap: 10 }} horizontalAlign={'space-between'}>
                        {showQuyHoach ?
                            <PrimaryButton
                                style={{ flex: 1 }}
                                text='Xem thông tin'
                                onClick={onLoadPress}
                                disabled={!(filterMenu() && filterMenu().length) || isLoading}
                            />
                            : null
                        }
                        {/* {listLabel.length ?
                            <DefaultButton
                                style={{ flex: 1 }}
                                disabled={isLoading}
                                text='Quay lại'
                                onClick={onNextPress}
                            />
                            : null
                        } */}
                    </Stack>
                    {isLoading ?
                        <Spinner label="Đang tải ..." />
                        : null
                    }
                    {errorMessage ?
                        <MessageBar
                            messageBarType={MessageBarType.error}
                            isMultiline={true}
                        >
                            <Text variant={'small'}>{errorMessage}</Text>
                        </MessageBar>
                        : null
                    }
                    <CardDownApp />
                </Stack>
            </div>
        </div>
    )
};

export default Layer;

const styles = {
    container: {
        root: {
            paddingBottom: 20,
            flex: 1,
            overflowY: 'scroll',
            // maxHeight:'calc(100% - 230px)', 
            marginRight: -16,
            paddingRight: 16,
        }
    },
    checkBoxV2: {
        root: {
            paddingBottom: 10,
        }
    },
    lableEmpty: {
        color: COLOR.darkGray,
        fontStyle: 'italic'
    }
};
